import NiceModal from "@ebay/nice-modal-react";
import { Chip, IconButton, Tooltip } from "@mui/material";
import { useCustomModel } from "components/context/CustomProvider";
import InfoOutlineIcon from "@mui/icons-material/InfoOutline";
import useCustomDataSource from "../useCustomDataSource";

const InnerObjectChip = ({ obj, objId, objDisplay, handleClick, disabled }) => {
  if (!obj && !objId) {
    throw new Error("Obj or objId must be provided to ObjectChipWithoutModel");
  }

  if (obj) {
    return (
      <Chip
        label={obj._title}
        variant="outlined"
        onClick={handleClick}
        size="small"
        disabled={disabled}
        color={handleClick ? "info" : "default"}
      />
    );
  }

  if (objDisplay) {
    return (
      <Chip
        label={objDisplay}
        variant="outlined"
        onClick={handleClick}
        size="small"
        disabled={disabled}
        color={handleClick ? "info" : "default"}
      />
    );
  }

  return (
    <Tooltip title={`Object Id : ${objId}`}>
      <IconButton
        onClick={handleClick}
        size="small"
        disabled={disabled}
        color={handleClick ? "info" : "default"}
      >
        <InfoOutlineIcon size="small" />
      </IconButton>
    </Tooltip>
  );
};

const ObjectChip = ({
  modelName,
  obj,
  objId,
  objDisplay,
  forceLoad,
  disabled,
}) => {
  if (!obj && !objId) {
    throw new Error("Obj or objId must be provided to ObjectChip");
  }
  if (obj && objId) {
    throw new Error(
      "Only one of object or objectId should be provided to ObjectChip",
    );
  }

  if (!modelName) {
    return (
      <InnerObjectChip
        obj={obj}
        objId={objId}
        objDisplay={objDisplay}
        disabled={disabled}
      />
    );
  }

  const dataSource = useCustomDataSource(modelName);

  const { data, isLoading } = dataSource.useOne(objId, {
    enabled: !!forceLoad && !obj,
  });

  const subModel = useCustomModel(modelName);

  const handleClick = (e) => {
    if (disabled) return;
    if (!subModel.viewModal) {
      console.warn(`No view modal defined for model: ${modelName}`);
      return;
    }
    NiceModal.show(subModel.viewModal, { id: objId || obj.id });
  };

  return (
    <InnerObjectChip
      obj={obj || (!!forceLoad && !obj && data)}
      objId={objId}
      objDisplay={objDisplay}
      handleClick={handleClick}
      disabled={disabled}
    />
  );
};

export default ObjectChip;
